module.exports = __webpack_public_path__ + "static/media/inamp.3c704730.png";